import type { JobStatus } from '@/features/jobs/types/job'
import { formatJobStatus } from '@/features/jobs/lib/format-job-status'
import { cn } from '@/lib/utils'

const jobStatusClassNames: Record<JobStatus, string> = {
  open: 'text-primary',
  in_progress: 'text-primary',
  completed: 'text-success',
  aborted: 'text-destructive',
  cancelled: 'text-destructive',
}

type JobStatusLabelProps = {
  status: JobStatus
}

export const JobStatusLabel = ({ status }: JobStatusLabelProps) => (
  <span className={cn('font-semibold uppercase', jobStatusClassNames[status])}>
    {formatJobStatus(status)}
  </span>
)
